export default "__VITE_ASSET__1edb0fb8__"